module.exports = __webpack_public_path__ + "47f0e616baf55e13ae7ad7b845e67d13.jpg";